export default (id) => {
  window.dispatchEvent(new CustomEvent('itemDelete', { detail: { id } }));
};
